import { resolveDynamicListItemLabel } from './dynamic-list-item-translation.util';

interface ListItemLike {
  id?: string;
  value?: string | null;
  translations?: Record<string, string> | object | null;
}

/** Flatten stored list DF values (id, array of ids, JSON array, `{id,value}`). */
export function coerceDynamicListValues(value: unknown): unknown[] {
  if (value === null || value === undefined || value === '') {
    return [];
  }
  if (Array.isArray(value)) {
    return value.flatMap(item => coerceDynamicListValues(item));
  }
  if (typeof value === 'string') {
    const trimmed = value.trim();
    if (trimmed.startsWith('[')) {
      try {
        const parsed = JSON.parse(trimmed) as unknown;
        if (Array.isArray(parsed)) {
          return coerceDynamicListValues(parsed);
        }
      } catch {
        return [trimmed];
      }
    }
    return [trimmed];
  }
  return [value];
}

function lookupKeysForListValue(item: unknown): string[] {
  if (item == null) return [];
  if (typeof item === 'object') {
    const obj = item as Record<string, unknown>;
    const keys: string[] = [];
    if (obj['id'] != null && obj['id'] !== '') keys.push(String(obj['id']));
    if (obj['value'] != null && obj['value'] !== '') {
      keys.push(String(obj['value']));
    }
    return keys;
  }
  return [String(item)];
}

function fallbackListLabel(item: unknown): string {
  if (item == null) return '';
  if (typeof item === 'object') {
    const obj = item as Record<string, unknown>;
    if (obj['value'] != null && obj['value'] !== '') {
      return String(obj['value']);
    }
    if (obj['id'] != null && obj['id'] !== '') {
      return String(obj['id']);
    }
    return '';
  }
  return String(item);
}

/**
 * Resolve list DF stored ids/values to display labels, joined with `, `.
 * Used by table cells and row-detail list fields.
 */
export function formatDynamicListSelection(
  value: unknown,
  listItems: ListItemLike[] | null | undefined,
  lang?: string | null,
  delimiter = ', '
): string {
  return coerceDynamicListValues(value)
    .map(item => {
      const keys = lookupKeysForListValue(item);
      const match = listItems?.find(li =>
        keys.some(
          key => String(li.id) === key || String(li.value ?? '') === key
        )
      );
      if (match) {
        return resolveDynamicListItemLabel(match, lang);
      }
      return fallbackListLabel(item);
    })
    .filter(label => label !== '')
    .join(delimiter ?? ', ');
}
